import { isArrayEmpty, react } from "../../../omnia"
import { TerramapContext } from "../../context"
import { FieldSelectionContext } from "../../fieldSelectionContext"
import { LayerType, ManagementTask, SelectionField } from "../../types"
import { FieldDetails } from "./FieldDetails"

import classes = react.classes

interface Props {

    field: SelectionField
    tasks: ManagementTask[]
    layerTypes: LayerType[]

    selectionContext: FieldSelectionContext

    focused: boolean

}

export function Field(props: Props) {

    const { dispatch, mapContext } = React.useContext(TerramapContext)

    const { field, tasks, selectionContext, layerTypes } = props
    const { fieldId, setIds, field: f } = field

    const selected = selectionContext?.isFieldSelected(fieldId)
    const focused = props.focused && (!selectionContext)

    const hasTasks = !isArrayEmpty(tasks)

    const handleClick = () => {

        if (selectionContext) {

            selectionContext.selectField(fieldId, !selected)

        }
        else {

            if (!focused) {
                mapContext.viewFieldExtent(field.key)
            }

            dispatch({ type: "setSelectedField", fieldKey: focused ? "" : field.key })

        }

    }

    return <div className={classes("field", focused && "expanded")}>

        <button type="button" onClick={handleClick}>

            <div className="name">
                {
                    hasTasks &&
                    <i className="fas fa-cog animate-spin" />
                }
                {
                    selectionContext &&
                    <i className={classes(selected ? "fas fa-check" : "far fa-square")} />
                }
                <span>{f.name}</span> ({f.area} ha)
            </div>

            {
                setIds &&
                <div className="sets">
                    {setIds.join(',')}
                </div>
            }

        </button>

        {
            focused && <FieldDetails field={field} tasks={tasks} layerTypes={layerTypes} />
        }

    </div>
}
